export default __webpack_public_path__ + "static/letgodoy-color-70b80952ff707dde563cf0658caad45e.png";